import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";
import { categories, MAIN_SITE_URL } from "@/mocks/categories";

export default function Header() {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [showMobileCats, setShowMobileCats] = useState(false);

  const nav = [
    { label: t("navHome"), href: "/", internal: true },
    { label: t("navSpreadsheet"), href: "#spreadsheet" },
    { label: t("navCategories"), href: "#categories" },
    { label: t("navShoppingGuide"), href: "/usfans-spreadsheet-guide", internal: true },
    { label: t("navFAQ"), href: "#faq" },
  ];

  return (
    <header className="sticky top-0 z-40 border-b-2 border-background-300 bg-white">
      <div className="mx-auto flex h-16 w-full items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
            <i className="ri-file-list-3-line text-lg"></i>
          </span>
          <span className="font-heading text-xl font-extrabold text-foreground-950">
            {t("siteName")}
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {nav.map((item) =>
            item.internal ? (
              <Link
                key={item.label}
                to={item.href}
                className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100 hover:text-foreground-950"
              >
                {item.label}
              </Link>
            ) : (
              <a
                key={item.label}
                href={item.href}
                className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100 hover:text-foreground-950"
              >
                {item.label}
              </a>
            )
          )}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <LanguageSwitcher />
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
          >
            {t("ctaExplore")}
          </a>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-900 transition-colors hover:bg-background-100 md:hidden"
          aria-label="Menu"
        >
          {menuOpen ? (
            <i className="ri-close-line text-2xl"></i>
          ) : (
            <i className="ri-menu-line text-2xl"></i>
          )}
        </button>
      </div>

      {menuOpen && (
        <div className="max-h-[calc(100vh-4rem)] overflow-y-auto border-t border-background-200 bg-white px-4 py-4 md:hidden">
          <nav className="flex flex-col gap-1">
            {nav.map((item) =>
              item.internal ? (
                <Link
                  key={item.label}
                  to={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="whitespace-nowrap rounded-lg px-4 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
                >
                  {item.label}
                </Link>
              ) : (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="whitespace-nowrap rounded-lg px-4 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
                >
                  {item.label}
                </a>
              )
            )}
          </nav>

          <button
            type="button"
            onClick={() => setShowMobileCats((v) => !v)}
            className="mt-2 flex w-full items-center justify-between rounded-lg px-4 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
          >
            <span>{t("navCategories")}</span>
            <span className="flex h-5 w-5 items-center justify-center">
              {showMobileCats ? (
                <i className="ri-arrow-up-s-line text-base"></i>
              ) : (
                <i className="ri-arrow-down-s-line text-base"></i>
              )}
            </span>
          </button>

          {showMobileCats && (
            <div className="mt-1 grid grid-cols-2 gap-1 rounded-lg border border-background-200 bg-background-50 p-2">
              {categories.map((c) => (
                <a
                  key={c.key}
                  href={c.url}
                  target="_blank"
                  rel="noopener nofollow"
                  onClick={() => setMenuOpen(false)}
                  className="whitespace-nowrap rounded-lg px-3 py-2 text-xs font-medium text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
                >
                  {t(`categories.${c.key}`)}
                </a>
              ))}
            </div>
          )}

          <div className="mt-3 flex items-center justify-between gap-3 border-t border-background-200 pt-3">
            <LanguageSwitcher />
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold text-white"
            >
              {t("ctaExplore")}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}